module.exports = __webpack_public_path__ + "frontend-assets/img/header_image_desktop.fcfc1879.png";